const Loader = ({ color, width, height, borderWidth, className }) => {
  return (
    <div
      className={`${
        borderWidth ? borderWidth : "border-2"
      } border-t-4 ${color} ${width || "w-12"} ${
        height || "h-12"
      } border-opacity-25 rounded-full animate-spin mx-auto ${className}`}
    ></div>
  );
};

export default Loader;
